import React from 'react'
import Bredcom from '../Bredcrumb/Main'
import DrinkImg from '../../assets/images/background/banner-image-2.jpg'
import DrinkMenu from './Menu';

function Main() {
  return (
    <>
        <Bredcom subtitle="Drink" title="" Img={DrinkImg} />
        <DrinkMenu />
    </>
  )
}

export default Main
